import * as Sentry from '@sentry/vue'
import { createPinia } from 'pinia'
import {
  Vue,
  vuetify,
} from 'src/configs'
import { useURLStore, useContextStore, useAnalysesStore } from 'src/store'
import initI18next from 'src/utils/initI18next'

async function clientPageRender(): Promise<void> {
  try {
    const pinia = createPinia()
    const urlStore = useURLStore(pinia)
    const contextStore = useContextStore(pinia)
    const analysesStore = useAnalysesStore(pinia)

    // @ts-ignore
    contextStore.$patch(state => {
      Object.assign(state.render, window.__RENDER_STATE__) // eslint-disable-line no-underscore-dangle
      Object.assign(state.context, window.__INITIAL_STATE__) // eslint-disable-line no-underscore-dangle
    })

    urlStore.$patch(state => {
      Object.assign(state.urls, window.__URL_STATE__) // eslint-disable-line no-underscore-dangle
      state.origin = window.__INITIAL_STATE__.global.sites.siteNamePD // eslint-disable-line no-underscore-dangle
    })

    analysesStore.$patch(state => {
      Object.assign(state, window.__ANALYSES_STATE__) // eslint-disable-line no-underscore-dangle
    })

    const stateScript = document.getElementById('ssr-state')

    if (stateScript) {
      stateScript.remove()
    }

    const featureFlags = {
      ...contextStore.context.feature_flags,
      ...contextStore.context.request?.feature_flags,
    }

    if (
      featureFlags.analyses_main_page_redesign
      || featureFlags.ff_lpu_branding_page_v4
    ) {
      await initI18next({
        userLanguage: contextStore.context?.current_language?.iso || 'ru',
      })
    }

    const container = document.getElementById('app')

    if (container) {
      const { default: component } = (await import(/* webpackMode: 'eager' */ `src/${contextStore.render.src}`))
      const app = new Vue({
        name: contextStore.render.src,
        pinia,
        vuetify,
        render: h => h(component),
      })

      app.$mount(container)
    }
  } catch (error: any) {
    console.log(`Рендер Vue на клиенте упал! ${error?.message}`) // eslint-disable-line
    Sentry.captureException(new Error(`Рендер Vue на клиенте упал! ${error?.message}`))
  }
}

export default clientPageRender
